import { Record } from 'immutable';
import { schema } from 'normalizr';

export const IssueCategory = new Record({
  id: undefined,
  name: undefined,
  obsolete: undefined,
  eligible_for_rma: undefined,
});

export const issueCategorySchema = new schema.Entity('issueCategories');

// for reading in nested models, object with { field: schema }
// issueCategorySchema.define({  });
